module.exports = __webpack_public_path__ + "img/Aquarius.d673687d.png";